import React from 'react';
import CreditCardsImage from 'assets/images/brandCards.png';
import { ThemePropType } from 'assets/styles/theme';
import {
  Col, FormGroup, FormLabel, Icon, Row, Text, ActionPortal,
  DefaultActionButtons,
  MaskedInput,
  ValidatedInput,
} from 'components';

import { inputsValidations } from 'validations/inputsFieldsValidations';

import { CreditCardContent, CreditCardWrapper } from './style';
import { Gray, Green, Purple } from 'constants/colors';

export default function PaymentCreditCard({
  theme,
  isValid,
  isLoading,
  onCancel,
  control,
  errors,
  watch,
  handleFields,
  register,
}) {
  const cardNumber = watch('cardNumber');
  const expirationDate = watch('expirationDate');
  const cvv = watch('cardSecurityCode');
  const cardHolder = watch('cardHolder');

  const fieldsValidations = inputsValidations.BR;

  return (
    <CreditCardWrapper theme={theme}>
      <Row>
        <Col md="12">
          <FormGroup>
            <FormLabel for="cardHolder" marginBottom="5px">Nome do titular</FormLabel>
            <ValidatedInput
              name="cardHolder"
              id="cardHolder"
              control={control}
              invalid={!!errors.cardHolder}
              errors={errors}
              defaultValue=""
              innerRef={register({
                required: fieldsValidations.required,
                ...fieldsValidations.cardName
              })}
              maxLength={22}
              placeholder="Digite o nome impresso no cartão"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormGroup>
            <FormLabel for="cardNumber" marginBottom="5px">Número do cartão</FormLabel>
            <MaskedInput
              control={control}
              name="cardNumber"
              id="cardNumber"
              placeholder="Ex.: 2423 3242 2325 2312"
              errors={errors}
              defaultValue=""
              rules={{
                required: fieldsValidations.required,
                ...fieldsValidations.cardNumber
              }}
              options={{ creditCard: true }}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <FormLabel for="expirationDate" marginBottom="5px">Validade</FormLabel>
            <MaskedInput
              control={control}
              valueWithMask={true}
              name="expirationDate"
              id="expirationDate"
              format="validThru"
              placeholder="Ex.: 12/2021"
              errors={errors}
              defaultValue=""
              rules={{
                required: fieldsValidations.required,
                validate: (validThru) => fieldsValidations.validThruCheck(validThru),
                ...fieldsValidations.validThru
              }}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <FormLabel for="cardSecurityCode" marginBottom="5px">Código de segurança</FormLabel>
            <MaskedInput
              control={control}
              name="cardSecurityCode"
              id="cardSecurityCode"
              format="numeric"
              placeholder="Ex.: 333"
              errors={errors}
              defaultValue=""
              maxLength={3}
              rules={{
                required: fieldsValidations.required,
                ...fieldsValidations.cardCvc
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <ActionPortal>
        <DefaultActionButtons
          theme={theme}
          isValid={isValid}
          backButtonStyle={{
            iconPosition: 'left',
            border: 'none',
            customBackgroundColor: 'transparent',
            customIconColor: Gray[400],
            customTextColor: Gray[400],
            title: 'Passo Anterior',
          }}
          nextButtonStyle={{
            customBackgroundColor: Purple[500],
            customIconColor: Gray[100],
            customTextColor: Gray[100],
            title: 'Continuar',
            loading: isLoading,
          }}
          onCancel={onCancel}
          onSubmit={() => {
            handleFields({
              cardNumber, cvv, expirationDate, cardHolder,
            });
          }}
        />
      </ActionPortal>
      <CreditCardContent>
        <img
          style={{ display: 'block' }}
          src={CreditCardsImage}
          alt="Boleto"
        />
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
          <Icon
            icon="lock"
            width="16px"
            height="16px"
            fontSize="14px"
            color={Green[400]}
          />
          <Text
            fontSize="12px"
            display="inline"
            margin="0 0 0 8px"
            color={Green[400]}
          >
            O pagamento é totalmente seguro. A Contele conta com a tecnologia SSL.
          </Text>
        </div>
      </CreditCardContent>
    </CreditCardWrapper>
  );
}

PaymentCreditCard.propTypes = {
  theme: ThemePropType.isRequired,
};
